import type { ActionListGroupItemType, ActionListGroupType } from '../types';
import type { ActionListItemDescriptor } from '@shopify/polaris';

import { ActionList, BlockStack, Box, Icon, Text } from '@shopify/polaris';
import { CheckIcon } from '@shopify/polaris-icons';

interface ActionListGroupProps {
  selected?: string;
  itemGroup: ActionListGroupType;
  hideTitle?: boolean;
  onHover?: (value: string | undefined) => void;
  onChange: (value: string) => void;
}
export const ActionListGroup: React.FC<ActionListGroupProps> = ({
  itemGroup,
  selected,
  hideTitle,
  onHover,
  onChange,
}) => {
  const getItems = (item: ActionListGroupItemType): ActionListItemDescriptor[] => {
    return (
      item.options?.map(({ value, label, description }) => ({
        id: value,
        content: label,
        onAction: () => onChange(value),
        truncate: true,
        active: value === selected,
        suffix: value === selected && <Icon source={CheckIcon} tone="success" />,
        helpText: (
          <Text variant="bodySm" as="span" truncate tone="disabled">
            {description}
          </Text>
        ),
        onMouseEnter: () => onHover?.(value),
        onMouseLeave: () => onHover?.(undefined),
      })) || []
    );
  };

  return (
    <BlockStack gap={hideTitle ? '0' : '300'}>
      {itemGroup.map((item, index) => (
        <Box key={index}>
          {!hideTitle && (
            <Text variant="headingMd" as="p">
              {item.title}
            </Text>
          )}
          <div className="ml-[-6px]">
            <ActionList actionRole="menuitem" items={getItems(item)} />
          </div>
        </Box>
      ))}
    </BlockStack>
  );
};
